import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Home from "./Home";
import Leistungen from "./Leistungen";
import Branchen from "./Branchen";
import Ueber from "./Ueber";
import Kontakt from "./Kontakt";

const Section = ({ id, children }) => (
  <div id={id} style={{ scrollMarginTop: "76px" }} data-testid={`section-${id}`}>
    {children}
  </div>
);

// Durchgehende Single-Page: alle Bereiche untereinander.
export default function OnePage() {
  const location = useLocation();

  useEffect(() => {
    // Bei Aufruf mit Hash (z. B. /#kontakt) sanft zum Abschnitt scrollen.
    const hash = location.hash ? location.hash.replace("#", "") : "";
    if (hash) {
      const t = setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
      return () => clearTimeout(t);
    }
    // Ohne Hash beim ersten Laden nach oben.
    window.scrollTo(0, 0);
  }, [location.hash, location.key]);

  return (
    <div data-testid="one-page">
      <Section id="start"><Home /></Section>
      <Section id="leistungen"><Leistungen /></Section>
      <Section id="branchen"><Branchen /></Section>
      <Section id="ueber"><Ueber /></Section>
      <Section id="kontakt"><Kontakt /></Section>
    </div>
  );
}
